import _ from 'lodash';
import React from 'react';
import {
  ApprovalStatusFilter,
  ClientApprovalStatusFilter,
  ExpenseBillableTypeFilter,
  ExpenseCategoryFilter,
  ExpenseReimbursableTypeFilter,
  InvoicedFilter,
} from '~/components';
import ReimbursedFilter from '~/components/filters/ReimbursedFilter';
import { useFeatures } from '~/hooks';
import ExpenseTypeFilter from './ExpenseTypeFilter';
import FiltersGroup from './FiltersGroup';
import ReportPeriodFilter from './ReportPeriodFilter';

export default function ExpenseFiltersGroup({ filters, onChange }) {
  const features = useFeatures();

  return (
    <FiltersGroup
      label="Expense Filters"
      filters={[
        filters.createdPeriod?.start,
        filters.createdPeriod?.end,
        filters.modifiedPeriod?.start,
        filters.modifiedPeriod?.end,
        filters.expenseApprovalStatuses,
        filters.expenseClientApprovalStatuses,
        filters.expenseInvoiced,
        filters.expenseCategories,
        filters.expenseTypeId,
        filters.expenseBillableTypeId,
        filters.expenseReimbursableTypeId,
        filters.expenseIsReimbursed,
      ]}>
      {_.has(filters, 'createdPeriod') && (
        <ReportPeriodFilter
          value={filters.createdPeriod}
          placeholder="Created Date Range"
          onChange={({ target: { value } }) => onChange({ createdPeriod: value })}
        />
      )}

      {_.has(filters, 'modifiedPeriod') && (
        <ReportPeriodFilter
          value={filters.modifiedPeriod}
          placeholder="Modified Date Range"
          onChange={({ target: { value } }) => onChange({ modifiedPeriod: value })}
        />
      )}

      {_.has(filters, 'expenseApprovalStatuses') && (
        <ApprovalStatusFilter
          value={filters.expenseApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ expenseApprovalStatuses: value })}
        />
      )}

      {features.clientApprovals && _.has(filters, 'expenseClientApprovalStatuses') && (
        <ClientApprovalStatusFilter
          value={filters.expenseClientApprovalStatuses}
          onChange={({ target: { value } }) => onChange({ expenseClientApprovalStatuses: value })}
        />
      )}

      {_.has(filters, 'expenseInvoiced') && (
        <InvoicedFilter
          value={filters.expenseInvoiced}
          onChange={({ target: { value } }) => onChange({ expenseInvoiced: value })}
        />
      )}

      {_.has(filters, 'expenseCategories') && (
        <ExpenseCategoryFilter
          value={filters.expenseCategories}
          onChange={({ target: { value } }) => onChange({ expenseCategories: value })}
        />
      )}

      {_.has(filters, 'expenseTypeId') && (
        <ExpenseTypeFilter
          value={filters.expenseTypeId}
          onChange={({ target: { value } }) => onChange({ expenseTypeId: value })}
        />
      )}

      {_.has(filters, 'expenseBillableTypeId') && (
        <ExpenseBillableTypeFilter
          value={filters.expenseBillableTypeId}
          onChange={({ target: { value } }) => onChange({ expenseBillableTypeId: value })}
        />
      )}

      {_.has(filters, 'expenseReimbursableTypeId') && (
        <ExpenseReimbursableTypeFilter
          value={filters.expenseReimbursableTypeId}
          onChange={({ target: { value } }) => onChange({ expenseReimbursableTypeId: value })}
        />
      )}

      {_.has(filters, 'expenseIsReimbursed') && (
        <ReimbursedFilter
          value={filters.expenseIsReimbursed}
          onChange={({ target: { value } }) => onChange({ expenseIsReimbursed: value })}
        />
      )}
    </FiltersGroup>
  );
}
